export const MuiStepIcon = {
    styleOverrides: {
        root: ({ theme }) => ({
            width: '1.5rem',
            height: '1.5rem',
            '&.Mui-completed': {
                fill: theme.palette.green.main,
            },
            '&.Mui-active': {
                fill: theme.palette.secondary.main,
            },
        }),
    },
};
